import { ClanResource, DivTooltip, TooltipBody, Divider } from '@wg/wows-react-uikit'
import React, { PureComponent } from 'react'
import { translate } from 'react-i18next'
import { t } from '../../../helpers/localization'
import styles from './ClanWallet.scss'

export type IProps = {
    clanResource: number,
    accumulativeResource: number
}

class ClanWallet extends PureComponent<IProps, any> {
    render() {

        return (
            <div className={styles.base}>
                <div className={styles.header}>
                    {t('Клановый ресурс')}
                </div>
                <DivTooltip
                    className={styles.value}
                    tooltipBody={(
                        <div className={styles.tooltip}>
                            <div className={styles.balanceRow}>
                                {t('В наличии:')}
                                <ClanResource amount={this.props.clanResource} isBold />
                            </div>
                            <Divider type={'major'} />
                            <div className={styles.balanceRow}>
                                {t('Всего получено:')}
                                <ClanResource amount={this.props.accumulativeResource} isBold />
                            </div>
                        </div>
                    )}
                >
                    <ClanResource amount={this.props.clanResource} isBold />
                </DivTooltip>
            </div>
        )
    }
}

export default translate()(ClanWallet)